import { render, staticRenderFns } from "./extra_benefits.vue?vue&type=template&id=88731a16&scoped=true&"
import script from "./extra_benefits.vue?vue&type=script&lang=js&"
export * from "./extra_benefits.vue?vue&type=script&lang=js&"
import style0 from "./extra_benefits.vue?vue&type=style&index=0&id=88731a16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88731a16",
  null
  
)

export default component.exports